import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";

import {BaseService} from "../../services/_base.service";
import {UserService} from "../../services/user.service";
import { ICRUDService } from '../../shared/crud-manager/crud.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorksService extends BaseService implements ICRUDService {
  params = [
    'action_buttons_type',
    'assignation_roles_id',
    'automatic_assignation',
    'can_change_status',
    'complete_child_works',
    'custom',
    'custom_field_ids',
    'custom_response_type',
    'custom_response_document_type',
    'form_fields',
    'global',
    'min_photos',
    'name',
    'next_custom_work_ids',
    'non_productive',
    'require_revision',
    'requirement_ids',
    'revision_max_score',
    'revision_roles_id',
    'revision_type',
    'roles_id',
    'sign_needed',
    'sign_roles',
    'sign_text',
    'status_id',
    'type',
  ];

  model = 'Work';

  constructor(public http:HttpClient, userService: UserService) {
    super()
  }

  index(value = null, page = 1, type = 'Work::Order') {
    return this.http.get(`${this.adminURL}/works`, this.getParams({ search: value, page, type }));
  }

  create(value, type = 'Work::Order') {
    Object.assign(value, { type });
    return this.http.post(`${this.adminURL}/works/`, {
      work: this.permitParams(value, ...this.params),
    }, this.getParams());
  }

  update(id: number, value) {
    return this.http.put(`${this.adminURL}/works/${id}`, {
      work: this.permitParams(value, ...this.params),
    }, this.getParams());
  }

  destroy(id: number) {
    return this.http.delete(`${this.adminURL}/works/${id}`, this.getParams());
  }

  restore(id: number) {
    return this.http.delete(`${this.adminURL}/works/${id}/restore`, this.getParams());
  }

  all(type = 'Work::Order') {
    return this.http.get(`${this.adminURL}/works/all`, this.getParams({ type }));
  }
}
